import { useRollbar } from '@rollbar/react';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { fetchSelector } from 'common/state/common';
import { FeatureGates } from 'common/types/account';
import { useRecoilValue } from 'recoil';
import { LogArgument } from 'rollbar';
import { API_URLS } from 'settings/api';

export const useGetFeatures = (): UseQueryResult<FeatureGates, unknown> => {
  const { fetchGet } = useRecoilValue(fetchSelector);
  const rollbar = useRollbar();
  return useQuery(
    ['features'],
    async () => {
      try {
        return await fetchGet<FeatureGates>(API_URLS.FEATURES);
      } catch (e: unknown) {
        rollbar.info('useGetFeatures error', e as LogArgument);
      }
    },
    {
      staleTime: Infinity,
    },
  );
};
